import { render, staticRenderFns } from "./control-panel.vue?vue&type=template&id=cc9e1308&scoped=true"
import script from "./control-panel.vue?vue&type=script&lang=ts"
export * from "./control-panel.vue?vue&type=script&lang=ts"
import style0 from "./control-panel.vue?vue&type=style&index=0&id=cc9e1308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9e1308",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ControlPanelSidebar: require('/build/apps/legacy/components/ControlPanel/Layout/ControlPanelSidebar.vue').default,MobileNav: require('/build/apps/legacy/components/Layout/MobileNav.vue').default,ZBreadcrumbItem: require('/build/apps/legacy/components/zeal/ZBreadcrumb/ZBreadcrumbItem/ZBreadcrumbItem.vue').default,ZBreadcrumb: require('/build/apps/legacy/components/zeal/ZBreadcrumb/ZBreadcrumb.vue').default,ZButton: require('/build/apps/legacy/components/zeal/ZButton/ZButton.vue').default,ZTab: require('/build/apps/legacy/components/zeal/ZTab/ZTab.vue').default,SidebarItem: require('/build/apps/legacy/components/Layout/Sidebar/SidebarItem.vue').default})
